module.exports = __webpack_public_path__ + "static/img/product_img2@2x.18559fb0.png";